import React from "react";
import { Grid, Header, Image, Segment } from "semantic-ui-react";
import styles from './OverviewModuleDescription.module.css';

const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const SpiritualModuleDescription: React.FC = () => {
  return (
    <Segment basic id={styles['medicalOverview']}>
    <p className={styles.overviewText} >
        Research evidence demonstrates the strong positive association between
        faith, religious attendance, and good health, particularly in the later
        years. Spirituality and religion are important aspects of life for older
        adults and help to shape individual, family, and communal relations
        across the life course.
      </p>
      <p className={styles.overviewText} >
        Religious involvement enhances well-being by providing social support,
        as well as a belief system that can offer hope and a sense of meaning
        and purpose in life.
      </p>
      <p className={styles.overviewText} >
        The tasks included in this module are designed to help you work with the
        older adult to enhance their spiritual and emotional well-being.
      </p>
            
      <Segment raised className={styles.segmentObjectives}>   
        <Header className={styles.objectivesGroupHeader} >Objectives </Header>     
        <Grid stackable>
          <Grid.Row columns='equal' stretched className={styles.objectivesItemRow} >
            <Grid.Column stretched className={`${styles.objectivesItemColumn} ${styles.objItemColLeft}`} >
              <Segment raised className={styles.objectivesItemWhiteBG} >  
                <Header as='h2' icon className={styles.objectivesItemHeader} >
                  <Segment className={styles.objectivesItemIconAndLabel} >
                    <Image src={`${iconRoute}DiscussIcon.png`} className={styles.objectivesItemHeaderImgIcon} />
                    <p className={styles.objectivesItemHeaderTitle} >DISCUSS </p>
                  </Segment>
                  <Header.Subheader className={styles.objectivesItemSubheader} > 
                    Have a discussion to learn about the older adult's current spiritual beliefs and needs.
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched className={`${styles.objectivesItemColumn} ${styles.objItemColMiddle}`} >
              <Segment raised className={styles.objectivesItemWhiteBG} >  
                <Header as='h2' icon className={styles.objectivesItemHeader} >
                  <Segment className={styles.objectivesItemIconAndLabel} >
                    <Image src={`${iconRoute}SupportIcon.png`} className={styles.objectivesItemHeaderImgIcon} />
                    <p className={styles.objectivesItemHeaderTitle} >SUPPORT </p>
                  </Segment>
                  <Header.Subheader className={styles.objectivesItemSubheader} > 
                    Help the older adult to create a support system within a faith-based organization.
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched className={`${styles.objectivesItemColumn} ${styles.objItemColRight} `} >
              <Segment raised className={styles.objectivesItemWhiteBG} >  
                <Header as='h2' icon className={styles.objectivesItemHeader} >
                  <Segment className={styles.objectivesItemIconAndLabel} >
                    <Image src={`${iconRoute}LearnIcon.png`} className={styles.objectivesItemHeaderImgIcon} />
                    <p className={styles.objectivesItemHeaderTitle} >LEARN </p>
                  </Segment>
                  <Header.Subheader className={styles.objectivesItemSubheader} > 
                    Learn how faith can help during difficult situations.
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </Segment>
  );
};

export default SpiritualModuleDescription;
